import { Alert } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import warningAnimation from "./assets/warningAnimation.json";

interface InvoicesDeleteConfirmationDialogProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onRequestClose: () => void;
  isDisabled: boolean;
}

export const InvoicesDeleteConfirmationDialog = ({
  isOpen,
  onCancel,
  onConfirm,
  onRequestClose,
  isDisabled,
}: InvoicesDeleteConfirmationDialogProps) => {
  const { t } = useTranslations();

  return (
    <div>
      <Alert
        isOpen={isOpen}
        img={
          <Lottie
            options={{
              animationData: warningAnimation,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
            width={80}
            height={80}
          />
        }
        title={t({
          id: "invoices.delete-confirmation-title",
          defaultMessage: "Confirm Action",
        })}
        content={t({
          id: "invoices.bulk-delete-confirmation-content",
          defaultMessage:
            "All selected documents will be permanently deleted and cannot be recovered",
        })}
        buttons={[
          {
            text: t({
              id: "common.cancel",
              defaultMessage: "Cancel",
            }),
            role: "close",
            onClick: onCancel,
          },
          {
            text: t({
              id: "common.proceed",
              defaultMessage: "Proceed",
            }),
            color: "tertiary",
            onClick: onConfirm,
            isDisabled,
          },
        ]}
        onRequestClose={onRequestClose}
      />
    </div>
  );
};
